/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useSearchParamsObject } from 'utils/url';
import { useBrandId } from 'AppProvider';
import useSupportedLanguage from 'utils/data/language/useSupportedLanguage';
import useReschedulableBookings from 'api/reschedule/useReschedulableBookings';
import useGuestReschedule from './useGuestReschedule';

type Params = {
  readonly cartId?: string;
  readonly bookingId?: string;
};

const sanitize = (value?: string) =>
  decodeURIComponent(value ?? '')
    .replace(/"/g, '')
    .split('&')[0] || undefined;

const useInitGuestReschedule = () => {
  const { cartId: rawCartId } = useParams<Params>();
  const baseUrl = '/carts/:cartId/guest-reschedule';
  const brandId = useBrandId();
  const languageCode = useSupportedLanguage();

  const matchGuestRescheduleSelectedBooking = useRouteMatch<Params>(
    `${baseUrl}/booking/:bookingId`,
  );

  const emptyParams: Params = {};

  const { bookingId } =
    matchGuestRescheduleSelectedBooking?.params ?? emptyParams;

  const { token } = useSearchParamsObject<{
    token?: string;
  }>();

  const { setCartData, setBookings, setSelectedBookingId, setIsLoading } =
    useGuestReschedule();

  const cartId = sanitize(rawCartId);
  const skip = !cartId || !token || !brandId;

  const { data: bookings, isLoading } = useReschedulableBookings(cartId, {
    skip,
    token,
    languageCode,
  });

  useEffect(() => {
    if (bookings && bookings.length > 0) {
      setBookings(bookings);
    }
  }, [bookings]);

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (cartId && token) {
      setCartData({
        cartId,
        token,
      });
    }
  }, [cartId, token]);

  useEffect(() => {
    if (bookingId) {
      setSelectedBookingId(bookingId);
    }
  }, [bookingId]);
};

export default useInitGuestReschedule;
